const getDecimalSeparator = () => {
  const separator = (0.1).toLocaleString().substr(1, 1);
  return () => separator;
};

export default getDecimalSeparator;
